import i18n from '@/plugins/vue-i18n';
import { RouteRecordRaw } from 'vue-router';
import { Actions, Subjects } from '@boqnet/permissions';

const { t } = i18n.global;

export default [
  {
    path: '/:organisationId?/client-dashboard',
    name: 'client-dashboard',
    component: () => import('@/views/client/ClientDashboard.vue'),
    meta: {
      title: t('routes.clients.pageTitles.dashboard'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.READ,
      subject: Subjects.CLIENT_DASHBOARD,
    },
  },
  {
    path: '/:organisationId?/client-variations',
    name: 'client-variations',
    component: () => import('@/views/client/ClientVariationsExternal.vue'),
    meta: {
      title: t('routes.clients.pageTitles.variations'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.READ,
      subject: Subjects.CLIENT_DASHBOARD,
    },
  },
  {
    path: '/:organisationId?/projects/:projectId/sites/:siteId/variations',
    name: 'variations',
    component: () => import('@/views/client/ClientVariationsInternal.vue'),
    meta: {
      title: t('routes.clients.pageTitles.variations'),
      layout: 'default',
      requiresAuth: true,
      action: Actions.LIST,
      subject: Subjects.CLIENT_VARIATION,
    },
  },
] as RouteRecordRaw[];
